module.exports = __webpack_public_path__ + "static/soc2-c92ac44e47a37f958fbb58f34fa63a60.png";